import { Controller } from "@hotwired/stimulus"
import Mark from "mark.js"
import { useDebounce } from "stimulus-use"

class ParliamentarianListSearch extends Controller {
  static targets = ["parliamentarian", "query"]
  static debounces = ["markSearch"]

  initialize() {
    useDebounce(this, { wait: 50 })
  }

  parliamentarianTargetConnected() {
    this.markSearch()
  }

  markSearch() {
    const marker = new Mark("#parliamentarian-list")
    const query = this.queryTarget.value.trim()

    marker.unmark()
    if (query) {
      marker.mark(query, {
        separateWordSearch: true,
        className: "search-highlight",
        filter(_node, term) {
          return term.length > 2
        },
      })
    }
  }
}

export { ParliamentarianListSearch }
